var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.result
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("create-vat-declaration"))),
          ]),
          _vm.isRunning
            ? _c("w-progress-linear", { staticClass: "progress" })
            : _vm._e(),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            [
              _c("w-tabs", {
                staticClass: "mb",
                attrs: { tabs: _vm.periodTabs },
                model: {
                  value: _vm.selectedPeriodTab,
                  callback: function ($$v) {
                    _vm.selectedPeriodTab = $$v
                  },
                  expression: "selectedPeriodTab",
                },
              }),
              _c("app-accounting-vat-declaration-period-month", {
                attrs: { show: _vm.selectedPeriodTab == 0 },
                on: {
                  input: function ($event) {
                    _vm.period = $event
                  },
                },
              }),
              _c("app-accounting-vat-declaration-period-quarter", {
                attrs: { show: _vm.selectedPeriodTab == 1 },
                on: {
                  input: function ($event) {
                    _vm.period = $event
                  },
                },
              }),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          decimals: 0,
                          label: _vm.$ct("common.Year"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.year,
                          callback: function ($$v) {
                            _vm.year = $$v
                          },
                          expression: "year",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          decimals: 2,
                          label: _vm.$ct("vat-grid", { value: 61 }),
                        },
                        model: {
                          value: _vm.data.Grid61,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "Grid61", $$v)
                          },
                          expression: "data.Grid61",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          decimals: 2,
                          label: _vm.$ct("vat-grid", { value: 57 }),
                        },
                        model: {
                          value: _vm.data.Grid57,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "Grid57", $$v)
                          },
                          expression: "data.Grid57",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          decimals: 2,
                          label: _vm.$ct("vat-grid", { value: 62 }),
                        },
                        model: {
                          value: _vm.data.Grid62,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "Grid62", $$v)
                          },
                          expression: "data.Grid62",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          decimals: 2,
                          label: _vm.$ct("vat-grid", { value: 91 }),
                        },
                        model: {
                          value: _vm.data.Grid91,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "Grid91", $$v)
                          },
                          expression: "data.Grid91",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("vat-request-refund") },
                        model: {
                          value: _vm.data.RequestRefund,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "RequestRefund", $$v)
                          },
                          expression: "data.RequestRefund",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("vat-request-payment-forms") },
                        model: {
                          value: _vm.data.RequestPaymentForms,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "RequestPaymentForms", $$v)
                          },
                          expression: "data.RequestPaymentForms",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("vat-nihil-listing") },
                        model: {
                          value: _vm.data.NihilListing,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "NihilListing", $$v)
                          },
                          expression: "data.NihilListing",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { disabled: _vm.isRunning, icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: _vm.isRunning, icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c("app-accounting-vat-declaration-preview", {
        attrs: { result: _vm.result, period: _vm.period },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }